<template>
  <div>
    <v-menu
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
        >
          <v-icon>menu</v-icon>
        </v-btn>
      </template>
      <v-layout row wrap white text-xs-center style="width:320px" py-3>
        <v-flex xs12 my-1>
          <router-link :to="{ name: 'register' }" v-if="!isLoggedIn && !isH2M">
            <v-btn flat dark style="background-color: #e91e63">
              Free 30 Day Trial
            </v-btn>
          </router-link>

          <router-link :to="{ name: 'h2mregister' }" v-if="!isLoggedIn && isH2M">
            <v-btn flat dark style="background-color: #e91e63">
              Free 60 Day Trial
            </v-btn>
          </router-link>

          <div v-if="isLoggedIn">
            <ShareCodeEntryControl />
          </div>
        </v-flex>
        <v-flex xs12 my-1>
          <router-link :to="{ path: '/' }">
            <v-btn
              flat
              large
            >
              Manipulatives
            </v-btn>
          </router-link>
        </v-flex>
        <v-flex xs12 my-1 v-if="!isClassroom">
          <v-btn
            flat
            large
            href="https://www.brainingcamp.com/resources"
            target="_blank"
          >
            Resources
          </v-btn>
        </v-flex>
        <v-flex xs12 my-1 v-else>
          <v-btn
            flat
            large
            href="https://www.brainingcamp.com/tutorials"
            target="_blank"
          >
            Tutorials
          </v-btn>
        </v-flex>
        <v-flex xs12 my-1>
          <v-btn
            flat
            large
            href="https://www.brainingcamp.com/pricing"
            target="_blank"
            v-if="!iosVisitor && !isClassroom && !isH2M"
          >
            Pricing
          </v-btn>
        </v-flex>
        <v-flex xs12 my-1>
          <v-btn
            flat
            large
            href="https://www.brainingcamp.com/hand2mind/pricing"
            target="_blank"
            v-if="!iosVisitor && !isClassroom && isH2M"
          >
            Pricing
          </v-btn>
        </v-flex>
        <v-flex xs12 my-1>
          <router-link :to="{ path: '/redeem' }">
            <v-btn
              flat
              large
              v-if="!isClassroom"
            >
              Redeem
            </v-btn>
          </router-link>
        </v-flex>
      </v-layout>
    </v-menu>
  </div>
</template>

<script>
import ShareCodeEntryControl from '@/components/ShareCodeEntryControl'

export default {
  components: {
    ShareCodeEntryControl
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.loggedIn;
    },
    isClassroom: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.type === 'classroom';
      }
      return false;
    },
    isH2M: function () {
      if (this.$store.getters.vendor === 'hand2mind') {
        return true;
      }

      return false;
    },
    iosVisitor: function () {
      if (this.$route.query.referrer === 'ios'){
        return true;
      }

      return false;
    }
  }
}
</script>

<style scoped>
.logo {
  cursor: pointer;
}

.lg {
  font-size: 14px;
  color: #56544d;
  font-weight: 500;
  text-transform: uppercase;
}
</style>